import type { FC, ReactNode } from "react";
import { Modal } from "@mantine/core";
import type { OpenState } from "./useOrderPage";

type CenteredModalProps = {
  modal: OpenState;
  children: ReactNode;
};

export const CenteredModal: FC<CenteredModalProps> = ({ modal, children }) => (
  <Modal
    centered
    transitionProps={{ transition: "fade", duration: 300 }}
    withCloseButton={false}
    size="xl"
    opened={modal.opened}
    onClose={modal.close}
    styles={{ title: { alignContent: "center", justifyContent: "center" } }}
  >
    {children}
  </Modal>
);
